/**
* Created by vouill on 8/18/18.
*/

<template>
  <div
    :class="['v-container', {'is-important': event.fields.isImportant}]">
    <div class="tags">
      <span
        v-for="tag in event.fields.tags"
        class="tag is-grey">
        {{ tag }}</span>
    </div>
    <router-link
      :to="`evenements/${event.fields.slug}`"
      class="v-title">

      <img
        class="picture"
        :src="`${img.fields.file.url}?q=80`">
    </router-link>
    <div class="article">
      <router-link
        :to="`/evenements/${event.fields.slug}`"
        class="v-title">{{ event.fields.title }}</router-link>
      <div class="date"><strong>{{ date }}</strong></div>
      <div class="address"><small><strong>{{ event.fields.address }}</strong></small></div>
      <div class="description">{{ event.fields.shortDescription }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.tags {
  position: absolute;
  top: 0.5em;
  left: 0.5em;
  z-index: 10;
}
.v-container {
  color: inherit;
  position: relative;
  height: 250px;
  font-size: inherit;
  font-weight: inherit;
  display: grid;
  grid-template-columns: 300px auto;
  box-shadow: 0 2px 10px 0 rgba(194, 194, 194, 0.5);
  transition: 0.2s ease-in;
  text-decoration: none;
  margin-bottom: 1em;
  a {
    height: inherit;
  }
  &.is-important {
    &:after {
      content: "";
      background-color: #ff9942;
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 20px;
    }
  }
  @media screen and (max-width: 900px) {
    height: inherit;
    grid-template-columns: 1fr;
    img {
      height: 150px;
    }
  }
  &:hover {
    box-shadow: 0 4px 10px 0 rgba(194, 194, 194, 0.9);
  }
}
.picture {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.article {
  flex-grow: 1;
  padding: 2em;
}
.v-title {
  font-family: "Roboto Slab";
  color: #ef6c00;
  font-size: 22px;
  font-weight: bold;
  &:hover {
    color: darken(#ef6c00, 10%);
  }
}

.authors {
  display: flex;
  align-items: center;
  align-content: center;
}
</style>

<script>
import moment from "moment";
export default {
  name: "MainEvent",
  props: { event: Object, img: Object },
  computed: {
    date: function() {
      return `${moment(this.event.fields.dateStarted).format(
        "MMMM Do YYYY"
      )} ${moment(this.event.fields.dateStarted).format("HH:mm")} - ${moment(
        this.event.fields.dateEnded
      ).format("HH:mm")}`;
    }
  }
};
</script>
